
const PATH_SEPARATOR = '/';

function parseQueryParams(params) {
    return '?' + $.param(params);
}

function parsePathParams(params) {
    return Array.isArray(params) ? PATH_SEPARATOR + (params.join(PATH_SEPARATOR)) : PATH_SEPARATOR + params;
}

function buildInternalDeeplink(params) {
    let parsedParams = '';
    Odigeo._.each(params, function(value, key) {
        parsedParams += `${key}=${value};`;
    });
    return parsedParams;
}

function deeplinkBuilder() {
    return {
        withBaseUrl: function(baseUrl) {
            this.baseUrl = baseUrl;
            this.queryParamFunction = parseQueryParams;
            return this;
        },
        withPathParams: function(pathParams) {
            this.pathParams = pathParams;
            return this;
        },
        withQueryParams: function(queryParams) {
            this.queryParams = queryParams;
            return this;
        },
        withInternalPage: function(page) {
            this.baseUrl = `#${page}${PATH_SEPARATOR}`;
            this.queryParamFunction = buildInternalDeeplink;
            return this;
        },
        build: function() {
            const baseUrl = this.baseUrl;
            const pathParams = this.pathParams !== undefined ? parsePathParams(this.pathParams) : '';
            const queryParams = Odigeo._.isPlainObject(this.queryParams) ? this.queryParamFunction(this.queryParams) : '';
            return `${baseUrl}${pathParams}${queryParams}`;
        },
    };
}

module.exports = deeplinkBuilder;
